'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var MENU_BROADCAST = exports.MENU_BROADCAST = 'MENU_BROADCAST';
var MENU_GROUP_BROADCAST = exports.MENU_GROUP_BROADCAST = 'MENU_GROUP_BROADCAST';


//////////////////
// WEBPACK FOOTER
// ./~/reactackle-menu/dist/broadcastsConstants.js
// module id = 98
// module chunks = 0